import { Injectable } from '@angular/core';

import { CmsComponentConfig, CmsFixes, FreeText } from '@interfaces/index';
import { ParagraphFreeTextData } from '@generated/content';

import { BaseComponentResolver } from '@services/_base/base-component-resolver/base-component-resolver';

@Injectable({ providedIn: 'root' })
export class FreeTextComponentResolver extends BaseComponentResolver {
  static override instance: FreeTextComponentResolver;
  private readonly componentType = FreeText.TypeEnum;

  static getInstance(): FreeTextComponentResolver {
    return (FreeTextComponentResolver.instance ||= new FreeTextComponentResolver());
  }

  public override resolveComponentConfig(node: ParagraphFreeTextData): CmsComponentConfig<FreeText.ComponentConfig> | null {
    const html = (node.attributes.field_text_ft as CmsFixes.CmsFreetextObject)?.['processed'].replaceAll("cms.spsglobal.com","spsglobal.com");
 
    return {
      componentType: this.componentType,
      config: { nodeId: BaseComponentResolver.getNodeId(node), html,anchor_id:node.attributes.field_anchor_id },
    };
  }
}
